import { colors } from '@mui/material';

const white = '#FFFFFF';
const black = '#000000';

export default {
  primary: {
    contrastText: white,
    dark: '#8a140f',
    main: '#e32118',
    light: '#ff3333'
  },
  secondary: {
    contrastText: white,
    dark: '#787878',
    main: '#aaaaaa',
    light: '#cccccc'
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white
  },
  divider: colors.grey[200],
  option1: {
    contrastText: white,
    dark: '#197ce3',
    main: '#4797eb',
    light: '#a3cbf5'
  },
  option2: {
    contrastText: white,
    dark: '#509c50',
    main: '#78ba78',
    light: '#bcdcbc'
  },
  option3: {
    contrastText: black,
    dark: '#ffbf00',
    main: '#ffcc33',
    light: '#ffe599'
  },
  option4: {
    contrastText: black,
    dark: '#f19100',
    main: '#ffad33',
    light: '#ffd699'
  }
};
